import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

export interface BookingGroup {
  booking_Group_ID: string;
  bookingGroup_Name: string;
}

export interface CreateJournalPlanningRecordForBIRequest {
  importRunId: string;
  bookingGroupId: string;
  applyWagePartitioning: boolean;
  applyRedistribution: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CreatebireportService {
  private apiUrl = environment.apiUrl + '/kbj-frontend/api/v1/Processing';
  private readonly httpOptions = { withCredentials: true };
  private http: HttpClient = inject(HttpClient);

  /**
   * Returns the booking groups (boekingsgroepen) available for the current context.
   */
  getBookingGroups(): Observable<BookingGroup[]> {
    return this.http
      .get<BookingGroup[] | null>(
        environment.apiUrl + '/kbj-frontend/api/v1/BookingGroup/ByContext',
        this.httpOptions,
      )
      .pipe(
        map((jsonData) => jsonData ?? []),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404 || err.status === 204) {
            return of([]);
          }
          return this.handleError(err);
        }),
      );
  }

  /**
   * Starts the journal planning processing for BI for an import run.
   */
  createJournalPlanningRecordForBI(
    request: CreateJournalPlanningRecordForBIRequest,
  ): Observable<unknown> {
    return this.http
      .post(this.apiUrl + '/CreateJournalPlanningRecordForBI', request, this.httpOptions)
      .pipe(catchError((err: HttpErrorResponse) => this.handleError(err)));
  }

  private handleError(err: HttpErrorResponse) {
    const errorMessage = `An error has occurred: ${err.error?.message ?? err.message}`;
    console.error(errorMessage);
    return throwError(() => errorMessage);
  }
}
